'use client';

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React, { useState, useEffect } from 'react';
import { TabsElement } from './elements';
import { Tab } from './Tab';
import { usePropDeprecation } from '../../util';
export const Tabs = /*#__PURE__*/React.forwardRef(({
  tabs,
  iconPosition = 'left',
  variant,
  activeTabIndex = 0,
  onChange,
  ariaLabel,
  tabWidth = 'hug',
  size,
  ...rest
}, fRef) => {
  usePropDeprecation({
    name: 'ariaLabel',
    value: ariaLabel,
    version: 'v5',
    alternative: 'aria-label'
  });
  usePropDeprecation({
    name: 'variant',
    value: variant,
    version: 'v5',
    alternative: 'size'
  });
  if (!size && variant === 'inline') {
    size = 'small';
  } else if (!size) {
    size = 'medium';
  }
  const [activeTabIdx, setActiveTabIdx] = useState(activeTabIndex ?? 0);
  const [tabRefs, setTabRefs] = useState([]); // list of references to each individual tab

  useEffect(() => {
    setActiveTabIdx(activeTabIndex);
  }, [activeTabIndex]);

  // Generates curried callback for populating tabRefs
  const setTabRef = index => React.useCallback(ref => {
    setTabRefs(tabRefs => [...tabRefs.slice(0, index), ref, ...tabRefs.slice(index + 1)]);
  }, []);
  const onClickHandler = (e, index, tabOnClick) => {
    if (activeTabIdx !== index) {
      setActiveTabIdx(index);
      tabOnClick === null || tabOnClick === void 0 ? void 0 : tabOnClick(e);
      onChange === null || onChange === void 0 ? void 0 : onChange({
        value: index
      });
    }
  };

  // Respond to user keyboard input to focus the correct tab
  const onKeyDownHandler = (index, e) => {
    const focusIndex = {
      End: -1,
      Home: 0,
      ArrowLeft: index - 1,
      ArrowRight: index + 1
    }[e.key];
    if (focusIndex !== undefined) {
      e.preventDefault();

      // Support out of bounds indices
      const ref = tabRefs[(focusIndex + tabRefs.length) % tabRefs.length];

      // Puts focus on tab and scrolls to show tab.
      ref === null || ref === void 0 ? void 0 : ref.focus({
        preventScroll: true
      });
      ref === null || ref === void 0 ? void 0 : ref.scrollIntoView({
        behavior: 'smooth',
        block: 'nearest'
      });
    }
  };
  return /*#__PURE__*/React.createElement(TabsElement, _extends({
    "data-aui": "tabs",
    ref: fRef,
    role: "tablist",
    "aria-label": ariaLabel
  }, rest), tabs.map(({
    onClick,
    ...tabRest
  }, index) => /*#__PURE__*/React.createElement(Tab, _extends({
    key: index,
    size: size,
    tabWidth: tabWidth,
    iconPosition: iconPosition,
    isActive: index === activeTabIdx,
    onClick: e => onClickHandler(e, index, onClick),
    onKeyDown: onKeyDownHandler.bind(null, index),
    ref: setTabRef(index)
  }, tabRest))));
});